import React, { useEffect, useState } from 'react'
import { getData } from '../../../../../services/library';
import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import ResumenGeneral from './components/ResumenGeneral';
import TablaPedidos from './components/TablaPedidos';
import SinResultados from './components/SinResultados';

function EntregasConRemitoCliente(props) {
    const [entregasConRemito, setEntregasConRemito] = useState(props.entregasConRemito)
    const [datosRow, setDatosRow] = useState(props.datosRow);
    const [pedidosRemito, setPedidosRemito] = useState([])
    const [loading, setLoading] = useState(true)
    const [expandedPedido, setExpandedPedido] = useState(null);
    
    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
          await getData("/envasado_pedidos/entregasconremito/"+props.datosRow.id, setPedidosRemito);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      };
      
      fetchData();
    }, [props.datosRow.id]);
    
    const handleClose = () => {
      setEntregasConRemito(!entregasConRemito);
      if (props.onClose) {
        props.onClose();
      }
    };
    
    const handleExpandPedido = (id) => {
      setExpandedPedido(expandedPedido === id ? null : id);
    };
    
    // Calcular totales
    const totalPedidos = pedidosRemito?.length || 0;
    const pedidosEntregados = pedidosRemito?.filter(p => p.valor === 'Entregado Con Remito').length || 0;
    
    return (
      <Dialog
        fullWidth
        open={entregasConRemito}
        onClose={() => handleClose()}
        maxWidth="xl"
        sx={{ '& .MuiDialog-paper': { maxHeight: '90vh' } }}
      >
        <Box sx={{ backgroundColor: "#1F618D", py: 1 }}>
          <DialogTitle sx={{ py: 1 }}>
            <Typography fontSize={18} align="center" color="#ffffff">
              Entregas a {props.datosRow.razon_social}
            </Typography>
            {/* {!loading && (
              <Typography variant="body2" align="center" color="#ffffff" sx={{ opacity: 0.9, mt: 0.5 }}>
                {totalPedidos} pedidos • {pedidosEntregados} con remito
              </Typography>
            )} */}
          </DialogTitle>
        </Box>
        
        <DialogContent sx={{ p: 2 }}>
          {loading ? (
            <Box textAlign="center" py={3}>
              <Typography variant="body1" color="textSecondary">
                Cargando...
              </Typography>
            </Box>
          ) : (
            <>
              <ResumenGeneral 
                totalPedidos={totalPedidos}
                pedidosEntregados={pedidosEntregados}
              />
              
              {pedidosRemito && pedidosRemito.length > 0 ? (
                <TablaPedidos 
                  pedidos={pedidosRemito}
                  expandedPedido={expandedPedido}
                  onExpandPedido={handleExpandPedido}
                />
              ) : (
                <SinResultados />
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    )
}

export default EntregasConRemitoCliente;